import React, { useEffect, useState } from 'react';
import TabPage from 'components/common/TabPage';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import $ from 'jquery';
import { Spinner, Modal, Button } from 'react-bootstrap';
import { changePasswordAPI, changePasswordDetailErrorAction } from 'actions/ChangePassword/changePasswordAction';
import { useNavigate } from 'react-router-dom';
import loader from '../../assets/img/loader.svg'

const tabArray = ['Change Password'];

export const ChangePassword = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const navigate = useNavigate();
  let token = localStorage.getItem('Token') || sessionStorage.getItem('Token');

  const changePasswordReducer = useSelector(
    state => state.rootReducer.changePasswordReducer
  );
  const changePasswordData = changePasswordReducer.changePasswordDetails;
  
  const formChangedReducer = useSelector(
    state => state.rootReducer.formChangedReducer
  );
  var formChangedData = formChangedReducer.formChanged;

  let isFormChanged = Object.values(formChangedData).some(
    value => value === true
  );

  useEffect(() => {
    $('#btnNew').hide();
    $('#btnSave').show();
  }, []);

  $('[data-rr-ui-event-key*="Change Password"]')
    .off('click')
    .on('click', function () {
      $('#btnSave').show();
      $('#btnSave').attr('disabled', false);
      $('#btnNew').hide();
    });

  const exitModule = () => {
    $('#btnExit').attr('isExit', 'true');
    if (isFormChanged) {
      setModalShow(true);
    } else {
      window.location.href = '/dashboard';
    }
  };

  const changePasswordValidation = () => {
    const oldPasswordErr = {};
    const newPasswordErr = {};
    const confirmPasswordErr = {};

    let isValid = true;
    let isPasswordValid = true;

    if (!changePasswordData.oldPassword || changePasswordData.oldPassword.trim() === '') {
      oldPasswordErr.Empty = 'Enter old password';
      isValid = false;
      isPasswordValid = false;
    } 

    if (!changePasswordData.newPassword || changePasswordData.newPassword.trim() === '') {
      newPasswordErr.Empty = 'Enter new password';
      isValid = false;
      isPasswordValid = false;
    } 

    if (changePasswordData.newPassword && !changePasswordData.confirmPassword) {
      confirmPasswordErr.Empty = 'Enter confirm password';
      isValid = false;
      isPasswordValid = false;
    }
    else  if (changePasswordData.confirmPassword != changePasswordData.newPassword) {
        confirmPasswordErr.Empty = 'Confirm password not match with new password';
        isValid = false;
        isPasswordValid = false;
      }
    
    if (!isPasswordValid) {
      if (!$('[data-rr-ui-event-key*="Change Password"]').hasClass('active')) {
        $('[data-rr-ui-event-key*="Change Password"]').trigger('click');
      }
    }
    if (!isValid) {
      var errorObject = {
        oldPasswordErr,
        newPasswordErr,
        confirmPasswordErr
      };

      dispatch(changePasswordDetailErrorAction(errorObject));
    }

    return isValid;
  };

  const changePasswordDetail = async () => {
    const headers = {
      Authorization: `Bearer ${JSON.parse(token).value}`
    };
    if (changePasswordValidation()) {
      const requestData = {
        oldPassword:changePasswordData.oldPassword,
        newPassword:changePasswordData.newPassword,
        confirmPassword:changePasswordData.confirmPassword,
        encryptedSecurityUserId:localStorage.getItem('EncryptedSecurityUserId'),
        modifyUser: localStorage.getItem('LoginUserName')
      }
      setIsLoading(true);
      await dispatch(
        changePasswordAPI(
          requestData,
          res => {
            toast.success(res?.data.message, {
              theme: 'colored',
              autoClose: 10000
            });
            setIsLoading(false);
            setModalShow(false);
            setTimeout(() => {
              navigate('/dashboard');
            }, 1000);
          },
          err => {
            setIsLoading(false);
            toast.error(err?.data.message, {
              theme: 'colored',
              autoClose: 10000
            });

          },
          headers
        )
      );
    }
  };

  const discardChanges = () => {
    $('#btnDiscard').attr('isDiscard', 'true');
    if ($('#btnExit').attr('isExit') == 'true') {
      window.location.href = '/dashboard';
    }
    setModalShow(false);
  };

  return (
    <>
      {/* {isLoading ? (
        <Spinner
      className="loader-color popup-loader position-fixed top-50 start-50 translate-middle z-index-5"
          // className="position-absolute start-50 loader-color"
          animation="border"
        />
      ) : null} */}
            {isLoading ? (
  <img
    src={loader}
    alt="Loading..."
    className="loader-gif position-fixed top-50 start-50 translate-middle z-index-5"
  />
) : null}

      {modalShow && (
        <Modal
          show={modalShow}
          onHide={() => setModalShow(false)}
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Confirmation
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <h4>Do you want to save changes?</h4>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" onClick={changePasswordDetail}>
              Save
            </Button>
            <Button
              variant="danger"
              id="btnDiscard"
              onClick={() => discardChanges()}
            >
              Discard
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      <TabPage
        tabArray={tabArray}
        module="ChangePassword"
        saveDetails={changePasswordDetail}
        exitModule={exitModule}
      />
    </>
  );
};

export default ChangePassword;